import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useUserStore } from '../stores/userStore';

const Logout = () => {
	const { signOut } = useUserStore();
	const navigate = useNavigate();

	useEffect(() => {
		signOut();
		navigate('/', { replace: true });
	}, []);

	return null;
};

export default Logout;
